import httpRequest from './httpRequest';

const initiate = async (uid) => {
    return await httpRequest.get(`/signup/${uid}`)
}

const create = async (uid, user) => {
    return await httpRequest.post(`/signup/${uid}`, user)
}

const reset = async (uid, user) => {
    return await httpRequest.put(`/signup/${uid}`, user)
}

const generate = async (user) => {
    return await httpRequest.post(`/signup`, user)
}

const getActiveSignupLinks = async () => {
    return await httpRequest.get('/signup')
}

export default {
    generate,
    initiate,
    create,
    reset,
    getActiveSignupLinks
}